import React, { useEffect, useState } from "react";
// import iconeTreeDots from "../assets/icons/three-dots.svg"

import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";

import { Pagination } from "@mui/material";
import {
  ArchiveIcon,
  Cross2Icon,
  HomeIcon,
  Pencil1Icon,
  PersonIcon,
  SewingPinFilledIcon,
  UploadIcon,
} from "@radix-ui/react-icons";
import toast from "react-hot-toast";
import { checkTagValidity, getUserProfil } from "../../Utils/Utils";
import { BASE_URL, CONFIRME_INTENTION, FICHIER_ABONNEMENT, RAPPORT_PAIEMENT } from "../../Utils/constant";
import model from '../../assets/model-fichier/model_abonnement.xlsx';
import { DetailIntention } from "../../components/Abonnement/DetailIntention";
import { UpdateDemandeIntention } from "../../components/Ajouter-intention/UpdateDemandeIntention";
import { ContentLoading } from "../../components/Widget/ContentLoading";
import { Pbo } from "../../components/Widget/Pbo";
import { Periode } from "../../components/Widget/Periode";
import { Tabs } from "../../components/Widget/Tab";
import { store, updateOne } from "../../services/service";
import { useIntentionStore } from "../../store/intentionStore";

const steps = [
  {
    label: "EN_ATTENTE_DE_CONFIRMATION",
    value: 1,
  },
  {
    label: "EN_ATTENTE_DE_PAIEMENT",
    value: 2,
  },
  {
    label: "EN_ATTENTE_DE_LIVRAISON",
    value: 3,
  },
  {
    label: "EN_ATTENTE_DE_IDENTIFICATION",
    value: 4,
  },
  {
    label: "EN_ATTENTE_DE_RENDEZ_VOUS",
    value: 5,
  },
  {
    label: "EN_ATTENTE_DE_SURVEY",
    value: 6,
  },
  {
    label: "EN_ATTENTE_DE_ACTIVATION",
    value: 7,
  },
  {
    label: "EN_ATTENTE_DE_RENDEZ_VOUS_DE_RACCORDEMENT",
    value: 8,
  },
  {
    label: "EN_ATTENTE_DE_RACCORDEMENT",
    value: 9,
  },
  {
    label: "EN_ATTENTE_DE_SOUSCRIPTION",
    value: 10,
  },
  {
    label: "EN_ATTENTE_DE_TEST",
    value: 11,
  },
];

const ListeAbonnements = () => {
  const { status } = useParams()
  const navigate = useNavigate();
  const [statusIntention, setStatusIntention] = useState(status === "TERMINER" ? status : "");
  const [abonnementStatus, setAbonnementStatus] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const [submit, setSubmit] = useState(false);
  const location = useLocation()
  const [active, setActive] = useState({
    index: 0,
    value: "Confirmé",
    label: "CONFIRMER",
    tag: "LISTE_CONFIRME",
  })
  const [selectItems, setSelectItem] = useState(null);
  const [fichier, setFichier] = useState([])
  const [message, setMessage] = useState("")
  const intentions = useIntentionStore();

  const listeTabsData = [
    {
      index: 0,
      value: "Confirmé",
      label: "CONFIRMER",
      tag: "LISTE_CONFIRME",
    },
    {
      index: 1,
      value: "Non confirmé",
      label: "NON_CONFIRMER",
      tag: "LISTE_NON_CONFIRME",
    },
  ];

  const filteredTabsData = listeTabsData
    .filter((tab) => checkTagValidity(tab.tag))
    .map((tab, index) => ({ ...tab, index }));

  useEffect(() => {
    if (filteredTabsData.length !== 0) {
      setActive(filteredTabsData[0])
    }
  }, []);

  useEffect(() => {
    intentions.intentionList(
      { page: 0, param: ``, size: 8 },
      `&statusConfirmation=${active ? active.label : ""}&status=${statusIntention === 'INACTIF' ? "" : statusIntention}&date=&isActive=${statusIntention === 'INACTIF' ? false : true}&sousMenu=${location.pathname.split('/')[2]}`
    );
  }, [active, statusIntention]);

  const more = (page) => {
    intentions.intentionList(
      { page: page - 1, param: "", size: 8 },
      `&statusConfirmation=${active ? active.label : ""}&status=${statusIntention}&date=&isActive=${statusIntention === 'INACTIF' ? false : true}&sousMenu=${location.pathname.split('/')[2]}`
    );
  };

  const handleDownload = () => {
    setSubmit(true)
    const user = getUserProfil()
    if (abonnementStatus !== "") {
      fetch(`${BASE_URL + RAPPORT_PAIEMENT}?model=${abonnementStatus}&username=${user?.username}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
        }),
      })
        .then(response => response.blob())
        .then(blob => {
          setSubmit(null)
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = url;
          a.download = `RAPPORT_${abonnementStatus}.xlsx`; // spécifiez le nom du fichier et son extension
          document.body.appendChild(a);
          a.click();
        })
        .catch(err => console.error('Erreur de téléchargement:', err));
    }
  };

  const handleChangeFichier = (e) => {
    console.log(e.target.files)
    const selectedFiles = e.target.files;
    const newFiles = Array.from(selectedFiles)
    setFichier(prevFiles => [...prevFiles, ...newFiles])
  }

  return (
    <div className="w-full ">
      <div className="lg:flex gap-x-2">
        <h1 className="font-mtn text-3xl font-extrabold text-black ">
          Abonnements
        </h1>
      </div>
      <div className="mt-3 lg:flex gap-1">
        <Tabs
          tabsData={filteredTabsData}
          active={active}
          setActive={setActive}
        />
        <div className="ml-auto">

          <button
            onClick={() => document.getElementById('upload').showModal()}
            className="mt-2 ml-auto btn btn-sm h-10 bg-black text-white">
            Charger un fichier
          </button>

          <dialog id="upload" className="modal rounded-none">
            <div className="modal-box w-10/12 max-w-xl">
              <div className="modal-action">
                <h1 className='font-mtn mr-auto text-2xl font-bold'>
                  Charger un fichier
                </h1>
                <p className="text-xs text-red-600">{message}</p>
                <form method="dialog">
                  <button id='close_upload' className="btn btn-sm"><Cross2Icon /></button>
                </form>
              </div>
              <div>
                <label className="form-contro w-full">
                  <div className="label flex flex-col justify-start items-start gap-1.5">
                    <span className="label-text  font-medium text-gray-400">
                    </span>
                    <div className="w-full">
                      <div className="text-black py-8 border-dashed border bg-gray-50 border-gray-300 px-3 my-2 w-full rounded-md shadow-sm "
                      >
                        <div className='flex justify-center mb-3'>
                          <UploadIcon />
                        </div>

                        <p className='text-center text-sm'>{
                          fichier.length !== 0 ? '' : 'Charger le fichier'
                        }</p>
                        <div className='flex justify-center'>
                          <input className='text-sm mx-auto file-input-bordered mb-3 file-input file-input-ghost w-full max-w-xs' type="file" id='fichier' onChange={handleChangeFichier} />
                        </div>
                      </div>
                    </div>
                  </div>
                </label>
                <a href={model} download="modelAbonnement" className='btn text-white bg-black btn-sm mx-1'>Telecharger le model</a>
                <button
                  onClick={() => {
                    setIsSubmit(true)
                    store(FICHIER_ABONNEMENT, 'multipart/form-data', {
                      username: getUserProfil()?.username,
                      liste: fichier[0]
                    }).then((res) => {
                      if (res.status === 200) {
                        setIsSubmit(null)
                        intentions.intentionList(
                          { page: 0, param: '', size: 8 },
                          `&statusConfirmation=${active.label}&status=${statusIntention}&date=&isActive=true&sousMenu=${location.pathname.split('/')[2]}`
                        );
                        document.getElementById('close_upload').click()
                        toast.success('Fichier chargé avec succès')
                      }
                    }).catch((err) => {
                      setIsSubmit(false)
                      setMessage(err?.response?.data?.donnee)
                    })
                  }}
                  disabled={isSubmit ? true : fichier.length === 0 ? true : false} className='font-mtn bg-main btn btn-sm'
                >
                  charger le fichier
                </button>

              </div>
            </div>
          </dialog >

          <button
            onClick={() => document.getElementById('rapport').showModal()}
            className="mt-2 ml-auto btn btn-sm h-10 bg-black text-white">
            Telecharger le rapport
          </button>

          <dialog id='rapport' className="modal bg-slate-900/70">
            <div className="modal-box w-11/12 max-w-xl h-96">
              <div className="flex items-center justify-between p-3">
                <div className="">
                  <h2 className="font-extrabold flex flex-row items-center text-lg mb-8 text-[#000000a8]">
                    Telechargement de rapport
                  </h2>
                </div>
                <form method="dialog">
                  <button
                    id="fermer_create_trajet"
                    className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                  >
                    ✕
                  </button>
                </form>
              </div>
              {/* <ExtractForm /> */}
              <div className="lg:flex lg:flex-row gap-2">
                <select
                  onChange={(e) => setAbonnementStatus(e.target.value)}
                  className="select pl-non w-full"
                >
                  <option selected value="">Selectionnez un element</option>
                  <option value="ALL">Tout les abonnements</option>
                  <option value="PAIEMENTS">
                    Abonnement payé
                  </option>
                  <option value="LIVRAISONS">
                    Abonnement livré
                  </option>
                  <option value="IDENTIFICATIONS">
                    Abonnement identifié
                  </option>
                  <option value="RENDEZ_VOUS">
                    Rendez-vous de survey programmé
                  </option>
                  <option value="SURVEYS">
                    Abonnement pour Survey Realisé
                  </option>
                  <option value="ACTIVATIONS">
                    Abonnement Activée
                  </option>
                  <option value="RACCORDEMENTS">
                    Abonnement raccordée
                  </option>
                  <option value="SOUSCRIPTIONS">
                    Abonnement souscrit
                  </option>
                  <option value="TESTS">
                    Abonnement testé
                  </option>
                </select>
                <button onClick={handleDownload} className="btn btn-sm bg-main text-xs">Telecharger le rapport</button>
              </div>

            </div>
          </dialog>

          {
            checkTagValidity("AJOUTER_INTENTION") ?
              <button
                onClick={() => {
                  navigate("enregistrement-intention");
                }}
                className="mt-2 btn btn-sm h-10 hover:bg-[#ffcb05] bg-[#ffcb05] "
              >
                Ajouter une intention
              </button>
              : null
          }
        </div>

      </div>
      <div className="my-3 lg:flex lg:flex-row md:flex-row xl:flex-row flex-col w-full justify-start items-start lg:items-center md:items-center xl:items-center  gap-2">
        <input
          onChange={(e) => {
            intentions.intentionList(
              { page: 0, param: e.target.value, size: 8 },
              `&statusConfirmation=${active.label}&status=${statusIntention}&date=&isActive=true&sousMenu=${location.pathname.split('/')[2]}`
            );
          }}
          type="text"
          placeholder="Rechercher element..."
          className="text-xs input input-bordered px-3 w-80 h-9 text-gray-900 placeholder:text-gray-400"
        />
        {active && active.value !== "NON_CONFIRMER" ? (
          <div className="lg:flex lg:flex-row justify-center items-center gap-2">
            <select
              onChange={(e) => setStatusIntention(e.target.value)}
              className="select pl-non"
            >
              <option selected value="">Tout les abonnements</option>
              <option value="TERMINER">Terminer</option>
              <option value="INACTIF">Abonnement inactif</option>
              <option value="EN_ATTENTE_DE_PAIEMENT">
                En attente de paiement
              </option>
              <option value="EN_ATTENTE_DE_LIVRAISON">
                En attente de livraison
              </option>
              <option value="EN_ATTENTE_DE_IDENTIFICATION">
                En attente d'identification
              </option>
              <option value="EN_ATTENTE_DE_SURVEY">En attente de survey</option>
              <option value="EN_ATTENTE_DE_ACTIVATION">
                En attente d'activation
              </option>
              <option value="EN_ATTENTE_DE_RACCORDEMENT">
                En attente de raccordement
              </option>
              <option value="EN_ATTENTE_DE_SOUSCRIPTION">
                En attente de souscription
              </option>
              <option value="EN_ATTENTE_DE_TEST">En attente de test</option>
            </select>
          </div>
        ) : null}
      </div>{" "}
      {active ? <div className="grid lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-2 mt-4 grid-cols-1 gap-2 gap-y-3">
        {intentions?.data?.data?.length === 0 ? (
          <div className="">
            <p>Aucune donnée</p>
          </div>
        ) : intentions?.data?.data?.length !== 0 && !intentions?.loading ? (
          intentions?.data?.data?.map((item) => (
            <div className="relative bg-white rounded-xl border-slate-200 border shadow-sm">
              <div className="rounded-t-xl flex items-center gap-3 border-b border-dashed border-amber-400 px-2 py-3">
                <p className="text-[12px] font-semibold">
                  N° {item?.numeroTicket}
                </p>
                <div className="ml-auto flex items-center gap-2">
                  <div
                    className={` px-1 border  rounded-full py-[2px] text-xs ${item?.statusConfirmation === "CONFIRMER"
                      ? "text-green-600"
                      : "text-red-500"
                      }  font-semibold`}
                  >
                    {item?.statusConfirmation?.toLowerCase().replace("_", " ").replace('er', 'é')}
                  </div>
                </div>
              </div>
              <div className=" px-3 py-2 ">
                <div className="items-center gap-2 space-y-3">
                  <Periode item={item} />
                  <Pbo pbo={item?.eligibilite?.pbo?.nom} port={item?.brin} />
                  <div className="flex gap-1 my-3">
                    <PersonIcon className="bg-gray-100 rounded-full w-8 h-8 p-2" />
                    <div>
                      <p className="text-[13px] font-medium">
                        {item?.client?.nomPrenoms}
                      </p>
                      <p className="text-xs flex font-semibold gap-2">
                        <span>{item?.client?.numero}</span> {" | "}{" "}
                        <span>{item?.client?.secondNumero}</span>{" "}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center gap-1 my-3">
                    <div>
                      <p className="text-[13px] font-medium">
                        Agent : {item?.agent?.nomPrenoms}
                      </p>
                    </div>
                  </div>
                  <h1 className="text-xs flex gap-1 items-center my-2">
                    Forfait :{" "}
                    {item?.forfait?.designation} - {item?.forfait?.categorie?.replace("_", "").toLowerCase()}
                  </h1>
                  <div className="pb-3 pt-1 border-b flex gap-4 items-center">
                    <p className="text-xs flex gap-1 items-center font-medium">
                      <HomeIcon />
                      {item?.batiment?.designation}
                    </p>
                    <p className="text-xs flex gap-1 font-medium">
                      <ArchiveIcon /> {item?.equipement?.designation}{" "}
                    </p>
                  </div>
                </div>
                <h1 className="my-2 text-[13px] font-medium flex items-center">
                  <SewingPinFilledIcon />
                  {item?.commune + ", " + item?.quartier}
                </h1>
                <div className="flex items-center gap-1">
                  <h5 className="text-xs font-medium ">Etape:</h5>
                  <p className=" bg-blue-50 text-blue-900 py-1 px-1 rounded-lg font-medium text-xs truncate">
                    {item?.status.toLowerCase().replace(/_/g, " ")}
                  </p>
                </div>
                {item?.status ===
                  "TERMINER" ? null : item?.statusConfirmation ===
                    "NON_CONFIRMER" ? (
                  <button
                    disabled={isSubmit ? true : false}
                    className="btn btn-sm bg-main my-3 font-mtn text-xs font-regular"
                    onClick={() => {
                      setIsSubmit(true);
                      updateOne(CONFIRME_INTENTION, item.id, {})
                        .then((res) => {
                          if (res.status === 200) {
                            intentions.intentionList(
                              { page: 0, param: ``, size: 8 },
                              `&statusConfirmation=${active.label}&status=${statusIntention}&date=&isActive=true&sousMenu=${location.pathname.split('/')[2]}`
                            );
                            toast.success("Intention confirmé");
                          }
                        })
                        .catch((err) => {
                          setIsSubmit(false);
                          toast.error(err?.response?.data?.donnee);
                        });
                    }}
                  >
                    Confirmer
                  </button>
                ) : (
                  <div className="flex items-center my-1">
                    {checkTagValidity("POURSUIVRE") ? <NavLink
                      className="btn btn-sm bg-main my-3 font-mtn text-xs font-regular"
                      to={`poursuivre-intention/${item?.numeroTicket
                        }/${steps.find((e) => e.label === item.status)?.value}`}
                    >
                      Poursuivre l'etape
                    </NavLink> : null}
                    {checkTagValidity("MODIFIER") ? <button
                      onClick={() => {
                        setSelectItem(item);
                        document.getElementById("edit").showModal();
                      }}
                      className="ml-auto text-white text-xs btn btn-sm bg-black"
                    >
                      <Pencil1Icon /> Modifier
                    </button>
                      : null}
                    {
                      checkTagValidity('DETAILS_INTENTION') ?
                        <button className="btn bg-main text-xs btn-sm" onClick={() => {
                          document.getElementById(`show${item.id}`).showModal()
                        }}>
                          Details
                        </button>
                        : null
                    }

                    <dialog id={`show${item.id}`} className="modal bg-slate-900/70">
                      <div className="modal-box w-11/12 max-w-2xl">
                        <div className="flex items-center justify-between p-3">
                          <div className="flex flex-row gap-2">
                            <div className=" flex justify-center items-center rounded-full bg-[#ffcb05] w-8 h-8">
                            </div>
                            <h2 className="font-extrabold flex flex-row items-center text-sm text-[#000000a8]">
                              Details d'intention
                            </h2>
                          </div>
                          <form method="dialog">
                            <button
                              id="fermer_create_trajet"
                              className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                            >
                              ✕
                            </button>
                          </form>
                        </div>
                        <DetailIntention item={item} />
                      </div>
                    </dialog>

                    <dialog id="edit" className="modal ">
                      <div className="modal-box w-10/12 max-w-2xl">
                        <div className="modal-action">
                          <h1 className="mr-auto text-2xl font-bold font-mtn">
                            Modification de l'abonnement
                          </h1>
                          <form method="dialog">
                            <button
                              id="fermer"
                              className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                            >
                              ✕
                            </button>
                          </form>
                        </div>
                        <UpdateDemandeIntention item={selectItems ?? ""} />
                      </div>
                    </dialog>

                  </div>
                )}
              </div>
            </div>
          ))
        ) : (
          <ContentLoading />
        )}
      </div> : null}
      <div className="my-3 flex justify-end">
        {active ? <Pagination
          onChange={(event, newValue) => more(newValue)}
          onSelect={(selectedPage) => more(selectedPage)}
          count={intentions?.data?.totalPages}
          variant="outlined"
          color="primary"
          shape="rounded"
        /> : null}
      </div>
    </div>
  );
};

export default ListeAbonnements;
